<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />
      <div class="layout-container">
        <expire-alert/>
        <app-layout-navbar />

        <div class="layout-content">
          <div class="router-transitions container-fluid d-flex align-items-stretch flex-grow-1 p-0">
            <router-view />
          </div>

          <!--app-layout-footer /-->
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
// import LayoutFooter from './LayoutFooter'
import ExpireAlert from '../cui-components/ExpireAlert'

export default {
  name: 'app-layout-2',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    // 'app-layout-footer': LayoutFooter,
    'expire-alert': ExpireAlert
  },

  mounted () {
    this.layoutHelpers.setCollapsed(true)
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  }
}
</script>
